import { PrimaryButton, Link } from "@fluentui/react";
import { styles } from "./experimentsTable.styles";
import { useNavigateEv2Experiments } from "../Hooks/UseNavigateToEv2Experiments";
import useAppInsights from "../Hooks/UseAppInsights";
import { NavType } from "../Shared/AppInsights";

interface ExperimentsTableNoExperimentsProps {
  extension: string;
}

const ExperimentsTableNoExperiments: React.FC<
  ExperimentsTableNoExperimentsProps
> = ({ extension }) => {
  const { navigateToExperiment } = useNavigateEv2Experiments();
  const { trackNavigationEvent } = useAppInsights(
    "ExperimentsTableNoExperiments",
  );
  return (
    <div className={styles.experimentsEmptyState}>
      <span style={{ fontSize: 48, marginBottom: 30 }}>🔬</span>
      <div style={{ fontWeight: 600, fontSize: 24, marginBottom: 8 }}>
        No experiments found for extension {extension}
      </div>
      <div style={{ fontSize: 16, marginBottom: 24 }}>
        Start by adding your first experiment!{" "}
        <Link
          href="https://eng.ms/docs/products/azure-portal-framework-ibizafx/experimentation/ev2"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            trackNavigationEvent({
              destination:
                "https://eng.ms/docs/products/azure-portal-framework-ibizafx/experimentation/ev2",
              function: "handleCreateExperimentClick",
              navType: NavType.External,
            });
          }}
        >
          Learn more
        </Link>
      </div>
      <PrimaryButton
        text="+ Create experiment"
        onClick={() => {
          const destination = navigateToExperiment(extension, undefined, {
            isCreate: true,
          });
          trackNavigationEvent({
            destination,
            function: "handleCreateExperimentClick",
            navType: NavType.Internal,
          });
        }}
      />
    </div>
  );
};

export default ExperimentsTableNoExperiments;
